/**
 * Category Filter Bar Component
 * Filter buttons for document categories
 */
import React from 'react';
import { Button } from '../../components/ui/button';
import { 
  FileText, 
  Banknote, 
  Plane, 
  Receipt, 
  FileCheck, 
  Folder,
  LayoutGrid
} from 'lucide-react';
import { DOCUMENT_CATEGORIES } from './documentCategories';

const CATEGORY_ICONS = {
  tax_documents: FileText,
  pay_earnings: Banknote,
  travel: Plane,
  receipts: Receipt,
  contracts: FileCheck,
  other: Folder
};

const CategoryFilter = ({ selectedCategory, onCategoryChange, categoryCounts }) => {
  const totalCount = Object.values(categoryCounts).reduce((sum, count) => sum + count, 0);

  return (
    <div className="flex flex-wrap gap-2" data-testid="category-filter">
      {/* All Documents Button */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => onCategoryChange(null)}
        className={`
          ${!selectedCategory 
            ? 'bg-amber-600 border-amber-600 text-white hover:bg-amber-700' 
            : 'border-slate-600 text-slate-400 hover:text-white hover:bg-slate-700'
          }
        `}
        data-testid="filter-all"
      >
        <LayoutGrid className="h-4 w-4 mr-2" />
        All
        <span className="ml-2 px-1.5 py-0.5 text-xs rounded-full bg-slate-700/50">
          {totalCount}
        </span>
      </Button>

      {/* Category Buttons */}
      {Object.entries(DOCUMENT_CATEGORIES).map(([key, category]) => {
        const Icon = CATEGORY_ICONS[key];
        const count = categoryCounts[key] || 0;
        const isSelected = selectedCategory === key;

        // Only show categories with documents
        if (count === 0) return null;

        return (
          <Button
            key={key}
            variant="outline"
            size="sm"
            onClick={() => onCategoryChange(isSelected ? null : key)}
            className={`
              ${isSelected 
                ? `${category.bgColor} ${category.borderColor} ${category.textColor}` 
                : 'border-slate-600 text-slate-400 hover:text-white hover:bg-slate-700'
              }
            `}
            data-testid={`filter-${key}`}
          >
            <Icon className="h-4 w-4 mr-2" />
            {category.label}
            <span className={`ml-2 px-1.5 py-0.5 text-xs rounded-full ${isSelected ? 'bg-white/20' : 'bg-slate-700/50'}`}>
              {count}
            </span>
          </Button>
        );
      })}
    </div>
  );
};

export default CategoryFilter;
